import { useEffect, useState } from 'react';
import { toQueryParamsString } from 'src/utils/ApiUtils';
import { LegacyAgency } from 'src/interfaces/api/Agency';
import useAuth from 'src/hooks/api/useAuth';

export interface DealsStats {
  dealsWonCount?: string;
  dealsWonPDC?: string;
  dealsLostCount?: string;
  dealsLostPDC?: string;
  dealsOngoingCount?: string;
  dealsOngoingPDC?: string;
}

type DealsStatsReturn = [undefined | DealsStats, boolean, undefined | string];

export default (agencyId: LegacyAgency['id'], startDate?: string, endDate?: string): DealsStatsReturn => {
  const [stats, setStats] = useState<DealsStats>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>();
  const { fetch } = useAuth();

  const fetchStats = (agencyId: LegacyAgency['id'], startDate: string, endDate: string): Promise<DealsStats> => {
    return fetch(`/api/dealStatistics/reports${toQueryParamsString({ agencyId, startDate, endDate })}`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    }).then((resp) => {
      if (resp.ok) {
        return resp.json();
      }

      throw new Error('Echec lors de la récupération des stats');
    });
  };

  useEffect(() => {
    if (startDate && endDate) {
      setLoading(true);
      fetchStats(agencyId, startDate, endDate)
        .then((data) => {
          setStats(data);
          setLoading(false);
        })
        .catch((e) => {
          setError(e.message);
          setLoading(false);
        });
    } else {
      setError('Vous devez renseigner une date début et de fin');
    }
  }, [agencyId, startDate, endDate]);

  return [stats, loading, error];
};
